export default "__VITE_ASSET__HG49MWcN__"